export const cleanStoreData = (data) => {
  let stores = data.locations || data
  if (stores) {
    stores = Object.values(stores)
  }

  return stores.map((store) => {
    const name = store.name.replace(/^SNS\s*/i, '')
    return {
      ...store,
      name
    }
  })
}
